// extracted by mini-css-extract-plugin
export default {"tooltip":"rU-z","arrow":"sU-z"};